export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_currencies(state, {currencies}) {
    state.currencies = currencies.data;
    state.totalCount = currencies.total;
    state.count = currencies.total;
    state.loaded = true;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
